import { DateTime } from 'luxon';

export function buildFundingYearStringArray() {
  const today = DateTime.now();
  let startOfInterval = today.minus({ years: 2 });
  const endOfInterval = today.plus({ years: 1 });
  const years: string[] = [];

  while (startOfInterval.startOf('year') < endOfInterval.startOf('year')) {
    const startYearSlice = startOfInterval.year.toString().slice(-2);
    const endYearSlice = (startOfInterval.year + 1).toString().slice(-2);

    years.push('FJ ' + startYearSlice + '/' + endYearSlice);
    startOfInterval = startOfInterval.plus({ years: 1 });
  }

  return years;
}
